import { render } from "./RegistrationDetails.vue?vue&type=template&id=1f65282c"
const script = {}

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/Event/Create/RegistrationDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1f65282c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1f65282c', __exports__)) {
    console.log('reload')
    api.reload('1f65282c', __exports__)
  }
  
  module.hot.accept("./RegistrationDetails.vue?vue&type=template&id=1f65282c", () => {
    console.log('re-render')
    api.rerender('1f65282c', render)
  })

}


export default __exports__